/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./reset-dco-config.vue?vue&type=template&id=d91eb432&scoped=true&"
import script from "./reset-dco-config.vue?vue&type=script&lang=js&"
export * from "./reset-dco-config.vue?vue&type=script&lang=js&"
import style0 from "./reset-dco-config.vue?vue&type=style&index=0&id=d91eb432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91eb432",
  null
  
)

export default component.exports